/** InsCoder WANG.J 2026-07-21 B + Client results carousel navigation and progress. **/
document.querySelectorAll('[data-results-section]').forEach((section) => {
  if (section.dataset.resultsInitialized === 'true') return;

  const track = section.querySelector('[data-results-track]');
  const progress = section.querySelector('[data-results-progress]');
  if (!track || !progress) return;

  const cards = [...track.children];

  if (!cards.length) return;
  section.dataset.resultsInitialized = 'true';

  const step = () => cards[1]?.offsetLeft - cards[0].offsetLeft || cards[0].offsetWidth;
  const update = () => {
    const max = track.scrollWidth - track.clientWidth;
    const visibleRatio = Math.min(1, track.clientWidth / track.scrollWidth);
    const travel = max > 0 ? track.scrollLeft / max : 0;
    progress.style.transform = `translateX(${travel * (1 - visibleRatio) * 100}%) scaleX(${visibleRatio})`;
  };

  section.querySelector('[data-results-prev]')?.addEventListener('click', () => {
    track.scrollBy({ left: -step(), behavior: 'smooth' });
  });
  section.querySelector('[data-results-next]')?.addEventListener('click', () => {
    track.scrollBy({ left: step(), behavior: 'smooth' });
  });
  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
});
/** InsCoder WANG.J 2026-07-21 E + Client results carousel navigation and progress. **/
